/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Permissions_Remove_Toast_Loading_DescriptionInputs */

const es_components_credentials_permissions_remove_toast_loading_description = /** @type {(inputs: Components_Credentials_Permissions_Remove_Toast_Loading_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitando acceso del usuario a esta credencial…`)
};

const en_components_credentials_permissions_remove_toast_loading_description = /** @type {(inputs: Components_Credentials_Permissions_Remove_Toast_Loading_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoking user access to this credential…`)
};

/**
* | output |
* | --- |
* | "Revoking user access to this credential…" |
*
* @param {Components_Credentials_Permissions_Remove_Toast_Loading_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_permissions_remove_toast_loading_description = /** @type {((inputs?: Components_Credentials_Permissions_Remove_Toast_Loading_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Permissions_Remove_Toast_Loading_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_permissions_remove_toast_loading_description(inputs)
	return en_components_credentials_permissions_remove_toast_loading_description(inputs)
});
export { components_credentials_permissions_remove_toast_loading_description as "components.credentials.permissions.remove.toast.loading.description" }